module.exports = {
    whiteBordered: "white-bordered",
    dark: "dark",
    lightGray: "lightGray",
    rounded: "rounded",
    default: "default"
};
